<template>
    <div>
        <b-modal class="full-image" header-class="d-none" centered footer-class="d-none"
            content-class="custom-model-wrap overflow-hidden text-center" title-class="" v-model="showImage">
            <template #default="{ cancel }">
                <button  class="close test-close-btn" variant="none" @click="cancel">x</button>
                <b-img rounded class="border pointer-event show-image" :src="image"></b-img>
            </template>
        </b-modal>
        <b-input-group>
            <b-form-input disabled :value="fileName"></b-form-input>
            <b-img v-if="['jpg', 'jpeg', 'png'].includes(fileName && fileName.split('.').pop())" :src="documentUrl" fluid alt="Uploaded Image" width="80" height="80"></b-img>
            <i v-else-if="['pdf'].includes(fileName && fileName.split('.').pop())" class="fa fa-file-pdf fa-2x"></i>
            <i v-else-if="['xls', 'xlsx'].includes(fileName && fileName.split('.').pop())" class="fa fa-file-excel fa-2x"></i>
            <div class="d-flex gap-2 ms-2">
                <b-button class="test-link-modal-cloud-btn" v-if="!image" :title="$translate('download')" :href="documentUrl" target="_blank"
                    :class="{ 'me-0': disabled }" :disabled="!value">
                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                </b-button>
                <b-img rounded class="border pointer-event profile-pic" @click="showImage = true" width="50" :src="image"
                    v-else></b-img>
                <b-button class="test-link-modal-cloud-upload-btn" v-if="!disabled" @click="uploadBtnClick" variant="info">
                    <b-icon icon="cloud-upload"></b-icon>
                </b-button>
            </div>
        </b-input-group>

        <b-modal :id="uploadKey" header-class="p-0" footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap" title-class="p-2" @ok="uploadFile" v-model="is_visible"
            :title="$translate('upload_file')">
            <b-overlay :show="!loaded" rounded="sm">
                <b-form-file id="uploadData" :placeholder="$translate('no_file_chosen')" ref="uploadData"
                    @change="uploadFile"></b-form-file>
            </b-overlay>
            <template #modal-footer="{ cancel }">
                <div class="d-flex">
                    <!-- <b-button vatiant="blue-button" size="fw" @click="ok">Ok</b-button> -->
                    <b-button class="test-close-label-btn" vatiant="blue-button" :disabled="!loaded" size="fw" @click="cancel">{{ $cancelLabel()
                    }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [popupMixins],
    data() {
        return {
            key: null,
            fileName: null,
            is_visible: false,
            uploadKey: 0,
            loaded: true,
            showImage: false,
            uploadedObjectURL: null,
        }
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        image: {
            type: String,
        }
    },
    computed: {
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
        documentUrl() {
            return `${this.mediaBaseUrl}/${this.key}`
        },
        uploadedImageUrl() {
            if (this.key) {
                return URL.createObjectURL(new File([], this.fileName)); // You may need to replace the empty array with the correct file information
            }
            return null;
        },
    },
    watch: {
        is_visible: function (val) {
            console.log('is_visible', val)
            if (!val) this.key = this.value
        },
        value: {
            immediate: true,
            handler: function (val) {
                this.convertValue(val)
            }
        },
    },
    created() {
        this.uploadKey =
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
    },
    mounted() {
        this.convertValue(this.value)
    },
    methods: {
        convertValue(value) {
            try {
                const obj = JSON.parse(value)
                this.key = obj.key
                this.fileName = obj.name
            } catch (err) {
                this.key = value
                this.fileName = value
            }
        },
        nextTick() {
            return new Promise(resolve => {
                this.$nextTick(() => resolve())
            })
        },
        uploadBtnClick() {
            this.is_visible = true
            this.$emit('upload-btn-clicked', 1)
        },
        async uploadFile(event) {
            this.loaded = !this.loaded
            try {
                let allowedTypes = this.$allowedTypes
                var fileName = event.target.files[0].name;
                var fileExtension = fileName.split('.').pop();
                let maxFileSize = this.$maxFileSize
                if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                    this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                    this.loaded = !this.loaded
                    return false;
                }
                if (maxFileSize < event.target.files[0].size) {
                    this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                    return false
                }
                const img = new Image();
                this.uploadedObjectURL= URL.createObjectURL(event.target.files[0]);
                img.src = this.uploadedObjectURL
                console.log('uploadFile:', event.target.files);
                await this.$store.dispatch('js_report/fetchCredentials')
                await this.nextTick()
                const { key, name } = await this.$store.dispatch(
                    's3files/s3singleUpload',
                    event.target.files
                )
                console.log('uploadFile: BINGO')
                this.key = key
                this.fileName = name
                await this.nextTick()
                const url = this.documentUrl
                const obj = { key, name, url }
                this.$emit('input', JSON.stringify(obj))
                this.is_visible = false
                this.doToast(this.$translate('success'), this.$translate('upload_image_success'), 'success')
                this.loaded = !this.loaded

            } catch (err) {
                this.loaded = !this.loaded
                this.doToast(this.$translate('error'), err.message, 'danger')
            }
        },
    },
}
</script>